export default {
    namespaced: true,
    state: {
      folders: [
        {
            id: 100,
            name: 'Alle Dokumente',
            docs: [100,101,102,103,104,105,106],
        },
        {
            id: 101,
            name: 'Dokumenten-Eingang',
            docs: [100,102,104,106],
        },
        {
            id: 102,
            name: 'Eigene Dokumente',
            docs: [101,103,105],
        },
        {
            id: 103,
            name: 'Steuersachen',
            docs: [100,102,105,106],
        },
    ],
      documents: [
        {
          id: 100,
          name: 'Führungszeugnis_FZ109428.pdf',
          seen: false,
          date: '08.02.2019',
          size: '69 Kb',
          extern: true,
        },
        {
            id: 101,
            name: 'Führungszeugnis_FZ109428.pdf',
            seen: true,
            date: '08.02.2019',
            size: '69 Kb',
            extern: false,
        },
        {
            id: 102,
            name: 'Führungszeugnis_FZ109428.pdf',
            seen: true,
            date: '08.02.2019',
            size: '69 Kb',
            extern: true,
        },
        {
            id: 103,
            name: 'Führungszeugnis_FZ109428.pdf',
            seen: false,
            date: '08.02.2019',
            size: '69 Kb',
            extern: false,
        },
        {
            id: 104,
            name: 'Führungszeugnis_FZ109428.pdf',
            seen: true,
            date: '08.02.2019',
            size: '69 Kb',
            extern: true,
        },
        {
            id: 105,
            name: 'Führungszeugnis_FZ109428.pdf',
            seen: true,
            date: '08.02.2019',
            size: '69 Kb',
            extern: false,
        },
        {
            id: 106,
            name: 'Führungszeugnis_FZ109428.pdf',
            seen: true,
            date: '08.02.2019',
            size: '69 Kb',
            extern: true,
        },
      ]
    },
    mutations: {
        SET_DOC_SEEN (state, id) {
            const document = state.documents.find(document => document.id == id);
            if(!document.seen) {
                document.seen = true;
            }
        },
        DELETE_DOC (state, id) {
            const document = state.documents.find(document => document.id == id);
            const docIndex = state.documents.indexOf(document);
            if(docIndex > -1) {
                state.documents.splice(docIndex, 1);
            }
        },
    },
    actions: {
        checkDoc({ commit, state }, id) {
            const document = state.documents.find(document => document.id == id);
            if(document) {
                commit('SET_DOC_SEEN', id);
            }
        },
        deleteDoc({ commit }, id) {
            commit('DELETE_DOC', id);
        },
    },
    getters: {
        getAllFolders: state => {
            return state.folders;
        },
      getAllDocs: state => {
        return state.documents;
      },
      getDocById: (state) => (id) => {
        return state.documents.find(document => document.id == id);
      },
      getDocsByUser: (state) => (id) => {
        return state.documents.filter(document => document.owner == id);
      },
      getDocsByIds: (state) => (ids) => {
        return state.documents.filter(document => ids.includes(document.id));
      },
      getDocsByTitle: state => (searchTerm) => {
        return state.documents.filter(document => document.author.toLowerCase().includes(searchTerm.toLowerCase()) 
        || document.subject.toLowerCase().includes(searchTerm.toLowerCase()));
      }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/documents.js